/**
 * Formato da sessão do paciente (antes UserService.prepareUserData/getFormattedUser).
 * O app ainda guarda o usuário da API com estes campos a mais; o `UserPatient` do core não é usado aqui.
 */
import { phoneCodes } from "@/utils/phoneCodes";
import { userAvatars } from "@/utils/userAvatars";

const DEFAULT_AVATAR = require("@/assets/img/avatars/1.png");

/** Telefone com a máscara do país (ex.: "(11)99999-9999"). */
export function maskedPhone(phone: string, countryCode: string) {
  try {
    const mask = (phoneCodes as any[]).find((p) => p.dial_code == countryCode)?.mask;
    return phone && countryCode && mask ? (phone as any).clear().conformToPattern(mask.replaceAll("9", "#")) : phone;
  } catch (e) {
    console.error(e);
    return phone;
  }
}

export function toSessionUser(raw: any) {
  const item = JSON.parse(JSON.stringify(raw));
  item.country_code = item.country_code || "+55";
  item.formatted_image = (userAvatars as any)[item.profile_image] || DEFAULT_AVATAR;
  const flag = (phoneCodes as any[]).find((r) => r.dial_code == item.country_code)?.flag;
  item.formatted_phone = `${flag}${item.country_code} ${maskedPhone(item.phone, item.country_code)}`;
  if (item.document_number === null) item.document_number = "";
  item.foreigner = item.foreigner || item.country_code !== "+55";
  // o código da parceria fica junto das regras dela (lido no checkout e na tela de parceria)
  if (item.partnership) item.partnership.info.code = item.partnership?.partnership_code?.code;
  return item;
}
